import PresenceAvailableFilled from 'mini-fluent-svg-icons/lib/icons/PresenceAvailableFilled';
import PresenceAvailableRegular from 'mini-fluent-svg-icons/lib/icons/PresenceAvailableRegular';
import PresenceOfflineFilled from 'mini-fluent-svg-icons/lib/custom-icons/PresenceOfflineFilled';
import PresenceOfflineRegular from 'mini-fluent-svg-icons/lib/icons/PresenceOfflineRegular';
import PresenceQuestionFilled from 'mini-fluent-svg-icons/lib/custom-icons/PresenceQuestionFilled';
import PresenceQuestionRegular from 'mini-fluent-svg-icons/lib/custom-icons/PresenceQuestionRegular';
import { PersonaMeetingResponse } from '../components/Persona.Props';

export default function determineMeetingResponseIcon(
    personaMeetingResponse: PersonaMeetingResponse,
    isSolid?: boolean
) {
    switch (personaMeetingResponse) {
        case PersonaMeetingResponse.Accept:
            return !!isSolid ? PresenceAvailableFilled : PresenceAvailableRegular;
        case PersonaMeetingResponse.Decline:
            return !!isSolid ? PresenceOfflineFilled : PresenceOfflineRegular;
        case PersonaMeetingResponse.Tentative:
            return !!isSolid ? PresenceQuestionFilled : PresenceQuestionRegular;
        default:
            // Ideally, this case doesn't happen
            return !!isSolid ? PresenceQuestionFilled : PresenceQuestionRegular;
    }
}
